// src/components/common/VisuallyHiddenHeading.tsx
// A real, level-1 heading for pages that deliberately render no visible
// title bar (KennelsPage/CalendarPage's space-constrained, fill-the-viewport
// layouts; BookingsListPage/BeingsListPage's preserved title-less design).
// Uses MUI's own visuallyHidden sx helper - the standard clip-rect/absolute-
// positioning technique - so the page still exposes exactly one accessible
// h1-equivalent per WCAG/page-structure expectations, without adding any
// visible UI or requiring the layout/height adjustments a full PageTitle
// bar would need on these pages.
//
// Same role/aria-level pattern as DialogBase's DialogTitleText fix and
// PageTitle.tsx's own FormPageTitle fix - applied at the usage site here
// too, since it lives on a plain Typography rather than a styled default.

import React from 'react';
import { Typography } from '@mui/material';
import { visuallyHidden } from '@mui/utils';

interface VisuallyHiddenHeadingProps {
  title: string;
}

const VisuallyHiddenHeading: React.FC<VisuallyHiddenHeadingProps> = ({
  title,
}) => (
  <Typography role="heading" aria-level={1} sx={visuallyHidden}>
    {title}
  </Typography>
);

export default VisuallyHiddenHeading;
